/*
 * Jira Ticket:
 * Created Date: Wed, 25th Mar 2020, 09:50:33 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import list from './list';
import edit from './edit';
import icon from '@material-ui/icons/Assignment';

export default {
  list,
  edit,
  icon,
};
